import * as i0 from '@angular/core';
import { Injectable, Inject, Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as i2 from '@bm-tax/sessions';
import { SessionsService } from '@bm-tax/sessions';
import * as i3 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BentoModule } from '@bento/bento-ng';

var EndpointRoute;
(function (EndpointRoute) {
    // Data entry Services
    EndpointRoute["Get_v1_ApplicationSetup"] = "/v1/application-setup/sections/{sectionName}";
})(EndpointRoute || (EndpointRoute = {}));
var UrlParameter;
(function (UrlParameter) {
    UrlParameter["SectionName"] = "sectionName";
})(UrlParameter || (UrlParameter = {}));

class DataRequestFormat {
}
class ApplicationSetupService {
    constructor(http, sessions, translate, notifications) {
        this.http = http;
        this.sessions = sessions;
        this.translate = translate;
        this.notifications = notifications;
        this.sectionName = 'firmSetupData';
    }
    /**
     * @description
     * Get the firm setup data for the office application setup
     *
     * @returns The firm setup data
     */
    getFirmSetup() {
        return this.sessions.getPath(this.sessions.taxServicesName).pipe(mergeMap((route) => this.http.get(this.firmSetupRequest(route))), map((response) => JSON.parse(response.data.fields.records.value)), catchError(response => {
            // 404 is expected if no data has been saved for this office yet
            if (!(response.error instanceof ErrorEvent) && response.status !== 404) {
                console.error('error ocurred while getting firm setup data');
            }
            // Default print options to true
            return of({
                printDateInPreparerBlock: true,
                printIncludeHeader: true,
                printIncludeHeaderClientId: true,
                printIncludeHeaderDate: true,
                printIncludeHeaderTime: true
            });
        })).toPromise();
    }
    /**
     * @description
     * Puts the firm setup data for the office application setup
     *
     * @param firmData to save to the office application endpoint
     */
    putFirmSetup(firmData) {
        const efinLength = firmData.hasOwnProperty('efin') ? firmData.efin.length : 0;
        if (efinLength > 0) {
            const isNumber = /^\d+$/.test(firmData.efin);
            if (!isNumber || efinLength !== 6) {
                this.notifications.setError(this.translate.instant('EFIN must be a 6 character numeric value'));
                return Promise.reject('EFIN must be a 6 character numeric value');
            }
        }
        const putProfileData = new DataRequestFormat();
        putProfileData.id = 'Office Firm Setup Data';
        putProfileData.fields = {
            records: {
                id: 'firmsetup',
                value: JSON.stringify(firmData),
                subgroup: {}
            },
        };
        putProfileData.subgroups = {};
        const headers = new HttpHeaders({ Accept: 'application/json', 'Content-Type': 'application/json' });
        return this.sessions.getPath(this.sessions.taxServicesName).pipe(mergeMap((route) => this.http.put(this.firmSetupRequest(route), { data: putProfileData }, { headers })), map(response => response), catchError(() => {
            console.error('error ocurred while saving profile data');
            return of();
        })).toPromise();
    }
    firmSetupRequest(taxServices) {
        const endpoint = this.sessions.buildRoute(taxServices, EndpointRoute.Get_v1_ApplicationSetup, {
            [UrlParameter.SectionName]: this.sectionName,
        });
        return endpoint;
    }
}
/** @nocollapse */ ApplicationSetupService.ɵfac = function ApplicationSetupService_Factory(t) { return new (t || ApplicationSetupService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.SessionsService), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject('NotificationServices')); };
/** @nocollapse */ ApplicationSetupService.ɵprov = i0.ɵɵdefineInjectable({ token: ApplicationSetupService, factory: ApplicationSetupService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApplicationSetupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.SessionsService }, { type: i3.TranslateService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['NotificationServices']
            }] }]; }, null); })();

function FirmsetupComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "input", 3);
    i0.ɵɵlistener("ngModelChange", function FirmsetupComponent_div_2_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.firmSetup.efin = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelementStart(4, "input", 5);
    i0.ɵɵlistener("ngModelChange", function FirmsetupComponent_div_2_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.firmSetup.generateSignatureDate = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "label", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelementStart(7, "input", 7);
    i0.ɵɵlistener("ngModelChange", function FirmsetupComponent_div_2_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.firmSetup.generateTaxpayerPin = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "label", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "h2", 9);
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵelementStart(11, "input", 10);
    i0.ɵɵlistener("ngModelChange", function FirmsetupComponent_div_2_Template_input_ngModelChange_11_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.firmSetup.printDateInPreparerBlock = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "label", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 12);
    i0.ɵɵelementStart(14, "input", 13);
    i0.ɵɵlistener("ngModelChange", function FirmsetupComponent_div_2_Template_input_ngModelChange_14_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.firmSetup.printIncludeHeader = $event; })("click", function FirmsetupComponent_div_2_Template_input_click_14_listener() { i0.ɵɵrestoreView(_r2); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.clickPrintHeader(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "label", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 15);
    i0.ɵɵelementStart(17, "input", 16);
    i0.ɵɵlistener("ngModelChange", function FirmsetupComponent_div_2_Template_input_ngModelChange_17_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.firmSetup.printIncludeHeaderClientId = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "label", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 15);
    i0.ɵɵelementStart(20, "input", 18);
    i0.ɵɵlistener("ngModelChange", function FirmsetupComponent_div_2_Template_input_ngModelChange_20_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.firmSetup.printIncludeHeaderDate = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "label", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 15);
    i0.ɵɵelementStart(23, "input", 20);
    i0.ɵɵlistener("ngModelChange", function FirmsetupComponent_div_2_Template_input_ngModelChange_23_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.firmSetup.printIncludeHeaderTime = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "label", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r0.firmSetup.efin);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r0.firmSetup.generateSignatureDate);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r0.firmSetup.generateTaxpayerPin);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r0.firmSetup.printDateInPreparerBlock);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r0.firmSetup.printIncludeHeader);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r0.firmSetup.printIncludeHeader)("ngModel", ctx_r0.firmSetup.printIncludeHeaderClientId);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r0.firmSetup.printIncludeHeader)("ngModel", ctx_r0.firmSetup.printIncludeHeaderDate);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r0.firmSetup.printIncludeHeader)("ngModel", ctx_r0.firmSetup.printIncludeHeaderTime);
} }
class FirmsetupComponent {
    constructor(sessions, applicationSetupService, changeDetect) {
        this.sessions = sessions;
        this.applicationSetupService = applicationSetupService;
        this.changeDetect = changeDetect;
        this.isInternalDev = false;
        this.loadFirmSetup = () => {
            return this.applicationSetupService.getFirmSetup().then(response => {
                this.firmSetup = response;
            }).catch(() => {
                this.firmSetup = {};
            }).finally(() => {
                // Detects changes and updates value
                this.changeDetect.detectChanges();
            });
        };
        this.saveFirmSetup = () => {
            return this.applicationSetupService.putFirmSetup(this.firmSetup);
        };
    }
    ngOnInit() {
        this.sessions.getInternalDevMode().subscribe(ret => {
            this.isInternalDev = (ret === true);
        }, () => {
            this.isInternalDev = false;
        });
        this.savePromise(this.saveFirmSetup);
        this.loadPromise(this.loadFirmSetup);
    }
    clickPrintHeader() {
        if (!this.firmSetup.printIncludeHeader) {
            this.firmSetup.printIncludeHeaderClientId = false;
            this.firmSetup.printIncludeHeaderDate = false;
            this.firmSetup.printIncludeHeaderTime = false;
        }
    }
}
/** @nocollapse */ FirmsetupComponent.ɵfac = function FirmsetupComponent_Factory(t) { return new (t || FirmsetupComponent)(i0.ɵɵdirectiveInject(i2.SessionsService), i0.ɵɵdirectiveInject(ApplicationSetupService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
/** @nocollapse */ FirmsetupComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FirmsetupComponent, selectors: [["bluemoon-ustax-firmsetup"]], inputs: { savePromise: "savePromise", loadPromise: "loadPromise" }, decls: 3, vars: 1, consts: [["translate", "Electronic Filing", 2, "margin-top", "0"], ["translate", "EFIN"], [4, "ngIf"], ["name", "efin", "type", "text", "maxlength", "6", 3, "ngModel", "ngModelChange"], [2, "margin", "15px 0 15px 0"], ["name", "signatureDate", "type", "checkbox", 3, "ngModel", "ngModelChange"], ["for", "signatureDate", "translate", "Automatically generate signature date (1040 only)"], ["name", "taxpayerPin", "type", "checkbox", 3, "ngModel", "ngModelChange"], ["for", "taxpayerPin", "translate", "Automatically generate taxpayer(s) PIN (1040 only)"], ["translate", "Print Options"], ["name", "printDate", "type", "checkbox", 3, "ngModel", "ngModelChange"], ["for", "printDate", "translate", "Print date in preparer's block"], [2, "margin", "15px 0 5px 0"], ["name", "printHeader", "type", "checkbox", 3, "ngModel", "ngModelChange", "click"], ["for", "printHeader", "translate", "Include header on statements and reports"], [2, "margin-left", "30px"], ["name", "printHeaderClientId", "type", "checkbox", 3, "disabled", "ngModel", "ngModelChange"], ["for", "printHeaderClientId", "translate", "Client ID/Client Name"], ["name", "printHeaderDate", "type", "checkbox", 3, "disabled", "ngModel", "ngModelChange"], ["for", "printHeaderDate", "translate", "Date"], ["name", "printHeaderTime", "type", "checkbox", 3, "disabled", "ngModel", "ngModelChange"], ["for", "printHeaderTime", "translate", "Time"]], template: function FirmsetupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "h2", 0);
        i0.ɵɵelement(1, "h3", 1);
        i0.ɵɵtemplate(2, FirmsetupComponent_div_2_Template, 25, 11, "div", 2);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.firmSetup);
    } }, directives: [i3.TranslateDirective, i4.NgIf, i5.DefaultValueAccessor, i5.MaxLengthValidator, i5.NgControlStatus, i5.NgModel, i5.CheckboxControlValueAccessor], styles: ["label[_ngcontent-%COMP%]{padding-left:4px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FirmsetupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'bluemoon-ustax-firmsetup',
                templateUrl: './firmsetup.component.html',
                styleUrls: ['./firmsetup.component.scss']
            }]
    }], function () { return [{ type: i2.SessionsService }, { type: ApplicationSetupService }, { type: i0.ChangeDetectorRef }]; }, { savePromise: [{
            type: Input
        }], loadPromise: [{
            type: Input
        }] }); })();

class FirmsetupModule {
}
/** @nocollapse */ FirmsetupModule.ɵfac = function FirmsetupModule_Factory(t) { return new (t || FirmsetupModule)(); };
/** @nocollapse */ FirmsetupModule.ɵmod = i0.ɵɵdefineNgModule({ type: FirmsetupModule });
/** @nocollapse */ FirmsetupModule.ɵinj = i0.ɵɵdefineInjector({ providers: [SessionsService, ApplicationSetupService], imports: [[
            CommonModule,
            BentoModule,
            FormsModule,
            NgbModule,
            TranslateModule.forChild(),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FirmsetupModule, { declarations: [FirmsetupComponent], imports: [CommonModule,
        BentoModule,
        FormsModule,
        NgbModule, i3.TranslateModule], exports: [FirmsetupComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FirmsetupModule, [{
        type: NgModule,
        args: [{
                declarations: [FirmsetupComponent],
                providers: [SessionsService, ApplicationSetupService],
                imports: [
                    CommonModule,
                    BentoModule,
                    FormsModule,
                    NgbModule,
                    TranslateModule.forChild(),
                ],
                exports: [FirmsetupComponent],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();

/*
 * Public API Surface of firmsetup
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApplicationSetupService, FirmsetupComponent, FirmsetupModule };
